"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingServiceNS = void 0;
var LoggingServiceNS;
(function (LoggingServiceNS) {
    LoggingServiceNS.LOGGING_SERVICE_ID = Symbol.for("LoggingService");
    let LoggingServiceLevels;
    (function (LoggingServiceLevels) {
        LoggingServiceLevels[LoggingServiceLevels["error"] = 0] = "error";
        LoggingServiceLevels[LoggingServiceLevels["warn"] = 1] = "warn";
        LoggingServiceLevels[LoggingServiceLevels["info"] = 2] = "info";
        LoggingServiceLevels[LoggingServiceLevels["debug"] = 3] = "debug";
        LoggingServiceLevels[LoggingServiceLevels["verbose"] = 4] = "verbose";
    })(LoggingServiceLevels = LoggingServiceNS.LoggingServiceLevels || (LoggingServiceNS.LoggingServiceLevels = {}));
})(LoggingServiceNS = exports.LoggingServiceNS || (exports.LoggingServiceNS = {}));
//# sourceMappingURL=logger.types.js.map